export default "__VITE_ASSET__l14862Zg__"